import {Col, Slider} from '@microfrontends/react-components';
import React, {useContext} from 'react';
import AppContext from '../../../../context/AppContext';
import SectionTitle from '../../components/PageTitle';
import {TJob} from '../../../CareerPath/Detail/types';
import {CardWrapper, JobsWrapper, RecommendJobsContainer} from './styles';
import {EDevice} from '../../../../containers/MainLayout';
import JobCard from './JobCard';
import {EJobLevel} from '../../types';

export type TJobSuggestionProps = {
	id: string
	jobList: TJob[]
	sectionTitle: string
	lightTitleColor?: boolean
	jobLevelId: EJobLevel
}
const RECOMMEND_JOBS_PER_PAGE = 3
const JobRecommendationSection = ({jobList, sectionTitle, lightTitleColor, id, jobLevelId}: TJobSuggestionProps) =>
	{
		
		const { breakpoint } = useContext(AppContext)
		const splitJobsByBlock = () => {
			const jobBlocks: TJob[][] = []
			let jobStore: TJob[] = []
			let jobStoreIndex: number = 0
			jobList.forEach((job: any) => {
				if (jobStore.length >= RECOMMEND_JOBS_PER_PAGE) {
					jobStore = []
					jobStoreIndex++
				}
				jobStore.push(job)
				jobBlocks[jobStoreIndex] = jobStore
			})
			return jobBlocks
		}
		return jobList?.length > 0 ? (
			<RecommendJobsContainer container={{ lg: 12 }} gutter={[16, 0]}>
				<Col>
					<SectionTitle id={id + '-section'} light={lightTitleColor}>{sectionTitle}</SectionTitle>
				</Col>
				<Col>
					<JobsWrapper>
						<div style={{margin: '10px 0', textAlign: 'right', textTransform: 'uppercase'}}>
							<a href={`${process.env.VNW_BASE_URL}/viec-lam?level=${jobLevelId}`} target="_blank">Xem tất cả</a>
						</div>
						<Slider
							id={id}
							autoEnable={false}
							slides={{
								elementPerView:
									breakpoint === EDevice.MOBILE ? 1 : 3,
								spaceBetween: 12
							}}
							pagination={{
								maxShow: 5
							}}
						>
							{splitJobsByBlock().map((block, index) => (
								<CardWrapper key={index}>
									{block.map((job, idx) => (
										<JobCard
											job={job}
											key={job.jobTitle}
											utm='utm_source=webVNW&utm_medium=Traffic&utm_campaign=Entry2023'
											isFinalIndex={
												idx + 1 === RECOMMEND_JOBS_PER_PAGE
											}
										/>
									))}
								</CardWrapper>
							))}
						</Slider>
					</JobsWrapper>
				</Col>
			</RecommendJobsContainer>
		) : null
	}
export default JobRecommendationSection
